// services/helpSupportApiService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_QWIK_MEDIC_API_URL;
const TOKEN = process.env.REACT_APP_QWIK_MEDIC_TOKEN;

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': `${TOKEN}`,
    'Content-Type': 'application/json',
  },
});

export const helpSupportApiService = {
  // Get all help support tickets
  getAllHelpSupport: async () => {
    try {
      const response = await axiosInstance.get('helpSupport/');
      return response.data.reverse(); // Show latest first
    } catch (error) {
      console.error('Error fetching help support tickets:', error);
      throw error;
    }
  },

  // Get single ticket
  getHelpSupport: async (id) => {
    try {
      const response = await axiosInstance.get(`helpSupport/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching help support ticket:', error);
      throw error;
    }
  },

  // Update ticket status
  updateHelpSupport: async (id, ticketData) => {
    try {
      const response = await axiosInstance.patch(`helpSupport/${id}`, ticketData);
      return response.data;
    } catch (error) {
      console.error('Error updating help support ticket:', error);
      throw error;
    }
  },

  // Delete ticket
  deleteHelpSupport: async (id) => {
    try {
      await axiosInstance.delete(`helpSupport/${id}`);
      return true;
    } catch (error) {
      console.error('Error deleting help support ticket:', error);
      throw error;
    }
  },
};